<template>
  <van-field
    v-bind="[$props, $attrs]"
    name="verifyCode"
    :rules="rules"
    class="required"
    type="number"
    maxlength="4"
    v-on="$listeners"
  >
    <template #button>
      <span class="yzm" :style="{ color }" @click="getYzm">{{ yzmstr }}</span>
    </template>
  </van-field>
</template>
<script>
import {getVerifyCode} from '@/api'
export default {
  name: 'VerifyCode',
  inheritAttrs: false,
  props: {
    // value: String,
    rules: {
      type: Array,
      default: () => [{ required: true, message: '请输入验证码' }]
    },
    label: {
      type: String,
      default: '验证码'
    },
    placeholder: {
      type: String,
      default: '请输入验证码'
    },
    contactNumber: {
      type: [String, Number],
      default: ''
    },
    color: {
      type: String,
      default: '#FC4E0A'
    }
  },
  data() {
    return {
      yzmstr: '获取验证码',
      yzmins: null
    }
  },
  methods: {
    async getYzm() {
      const vm = this
      if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(vm.contactNumber)) {
        vm.$toast.fail('请输入正确的手机号')
        return false
      }
      if (vm.yzmstr === '获取验证码' || vm.yzmstr === '重新获取') {
        vm.yzmstr = '60s'
        let minute = 60
        let timer
        const resp = await getVerifyCode(vm.contactNumber)
        if (resp.status === 1) {
          clearInterval(timer)
          timer = setInterval(() => {
            if (minute === 0) {
              clearInterval(timer)
              vm.yzmstr = '重新获取'
            } else {
              minute -= 1
              vm.yzmstr = minute + 's'
            }
          }, 1000)
        } else {
          vm.yzmstr = '重新获取'
        }
        vm.$once('hook:beforeDestroy', () => {
          clearInterval(timer)
        })
        vm.$toast(resp.msg)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.yzm {
  color: #fc4e0a;
  font-size: 13px;
}
</style>
